import { Group } from "@mantine/core"
import { ListTableActionIconGroup } from "../../-components/list-table-action-icon-group"
import { useUserLocalStorage } from "../../-components/use-user-local-storage"
import { Page } from "../../../../-components/Page"
import { ResourceTypeCategory } from "../../../../@client/Theasoft_DataClasses_Dispo"
import { ResourcesCardList } from "./ResourcesCardList"
import { ResourcesTable } from "./ResourcesTable"
import { ResourceTypeCategorySelect } from "./ResourceTypeCategorySelect"
import { useNavigate } from "@tanstack/react-router"
import { ResourceObjectsSegmentControl } from "./ResourceObjectsSegmentControl"
import { useGetResourceTypeCategoriesSuspense } from "@/orval/gen"

export function ResourcesPage() {
  const [view, setView] = useUserLocalStorage<"table" | "list">({
    key: "resources-page-view",
    defaultValue: "list",
  })

  const { data: categories } = useGetResourceTypeCategoriesSuspense()

  const [category, setCategory] = useUserLocalStorage<ResourceTypeCategory>({
    key: "resource-category",
    defaultValue: categories[0],
  })
  const navigate = useNavigate()
  const navigateToObjects = () =>
    navigate({
      to: "/app/resources/resource-objects",
      search: { filter: { available: true } },
    })
  return (
    <Page
      crumbOverride={() => (
        <Group>
          <ResourceTypeCategorySelect value={category} onChange={setCategory} />
          <ResourceObjectsSegmentControl
            category={category}
            value={"Resources"}
            onChange={navigateToObjects}
          />
        </Group>
      )}
      buttonGroupProps={{
        children: (
          <ListTableActionIconGroup
            value={view}
            onChange={(value) => {
              setView(value)
            }}
          />
        ),
      }}
      titleGroupProps={{ align: "start" }}
    >
      {view === "list" ? (
        <ResourcesCardList category={category} />
      ) : (
        <ResourcesTable category={category} />
      )}
    </Page>
  )
}
